import '@/user/common';
import '@/shared/calendar';
import '@/user/page/fair/reserve_modal';
import '@/user/page/fair/search_modal';

// 同日開催のフェアをもっと見る
const moreBtn = document.getElementsByClassName('js-more_btn');
Array.from(moreBtn).map((btn) => {
    btn.addEventListener('click', e => {
        const parent = e.currentTarget.parentNode;
        let label = parent.querySelector('.js-more_label');
        let closeLabel = parent.querySelector(".js-more_close");

        if (label.style.display === "none") {
            label.style.display = "block";
            closeLabel.style.display = "none";
            parent.classList.remove('is-open');
        } else {
            closeLabel.style.display = "block";
            label.style.display = "none";
            parent.classList.add('is-open');
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // 絞り込み機能のときは検索ボックスからスタート
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('fair-search')) {
        const element = document.querySelector('.js-fair-result-conditions');

        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
});

// カルーセルを閉じた時、一番最初のカセットに戻る
const closeBtn = document.getElementsByClassName('js-more_close');
Array.from(closeBtn).forEach((btn) => {
    btn.addEventListener('click', (e) => {
        const parent = e.currentTarget.closest('.js-fair-result'); // ここで適切な親要素を見つける
        if (parent) {
            parent.scrollIntoView({
                behavior: 'smooth'
            });
        }
    });
});

// ソート条件変更
const sortSelect = document.getElementById('js-sort_select');
if (sortSelect) {
    const fairChecked = 1;
    const dataChecked = 0;
    const fairParam = 'group_by=id';
    const currentUrl = new URL(window.location.href);
    const currentParams = currentUrl.searchParams;
    const searchParams = new URLSearchParams(currentUrl.search);

    sortSelect.selectedIndex = dataChecked;
    // クエリパラメータがついているときはフェア順にチェック
    if (searchParams.has('group_by')) {
        sortSelect.selectedIndex = fairChecked;
    }

    // 選択された条件でリダイレクト
    sortSelect.addEventListener('change', (e) => {
        const sortData = e.currentTarget.value;
        const hasFairType = Array.from(searchParams.keys()).some(key => key.startsWith('fair_type['));
        const hasDate = Array.from(searchParams.keys()).some(key => key.startsWith('date['));
        const pathName = currentUrl.pathname;
        // ページャーのURLパスを削除
        const firstPagePath = pathName.replace(/\/page\d+\//, '/');
        // 絞り込みのクエリパラメータを削除
        currentParams.delete('fair-search');

        switch (true){
            // 絞り込みクエリパラメータなし+表示切り替えが日付
            case sortData === 'date' && !hasFairType && !hasDate:
                window.location.href = `${currentUrl.origin}${firstPagePath}`;
                break;
            // 絞り込みクエリパラメータなし＋表示切り替えがフェア
            case sortData === 'fair' && !hasFairType && !hasDate:
                // ページャーパラメータの削除
                currentParams.delete('page');
                window.location.href = `${currentUrl.href}?${fairParam}`;
                break;
            // 絞り込みクエリパラメータあり＋表示切り替えが日付
            case sortData === 'date' && (hasFairType || hasDate):
                // フェア順パラメータの削除
                currentParams.delete('group_by');
                window.location.href = `${currentUrl.origin}${firstPagePath}${currentUrl.search}`;
                break;
            // 絞り込みクエリパラメータあり＋表示切り替えがフェア
            case sortData === 'fair' && (hasFairType || hasDate):
                // ページャーパラメータの削除
                currentParams.delete('page');
                window.location.href = `${currentUrl.href}&${fairParam}`;
                break;
            default:
                window.location.href = `${currentUrl.origin}${firstPagePath}`;
                break;
        }
    });
}
